<template>
  <div class="main-content-container overflow-hidden">
    <ol class="breadcrumb mt-[12px] md:mt-0">
      <li v-if="this.$route.query.is_from_reports === '1'"
          class="breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
        <a style="text-underline: none;" href="/reports/manage"
           class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
          Отчет
        </a>
      </li>
      <li v-else
          class="breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
        <a style="text-underline: none;" href="/tasks/manage"
           class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
          Задачи
        </a>
      </li>
      <li class="breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
        Мой профиль
      </li>
    </ol>
    <PageTitle pageTitle="Мой профиль" subTitle="Мой профиль"/>

    <MyProfile/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import MyProfile from "@/components/Others/MyProfile/index.vue";

export default defineComponent({
  name: "WidgetsPage",
  components: {
    PageTitle,
    MyProfile,
  },
});
</script>
